const KEY = 'reg_session_token';
const EXPIRY_KEY = 'reg_session_expires';
const RESULT_KEY = 'reg_result_passed';

function getSessionToken(): string | null {
  const token = window.sessionStorage.getItem(KEY);
  const expires = window.sessionStorage.getItem(EXPIRY_KEY);
  if (!token || !expires) return null;
  if (new Date(expires) < new Date()) {
    clearSession();
    return null;
  }
  return token;
}

function setSessionToken(token: string, expiresAt: string): void {
  window.sessionStorage.setItem(KEY, token);
  window.sessionStorage.setItem(EXPIRY_KEY, expiresAt);
}

function setResultPassed(): void {
  window.sessionStorage.setItem(RESULT_KEY, '1');
}

function hasResultPassed(): boolean {
  return window.sessionStorage.getItem(RESULT_KEY) === '1';
}

function clearSession(): void {
  window.sessionStorage.removeItem(KEY);
  window.sessionStorage.removeItem(EXPIRY_KEY);
  window.sessionStorage.removeItem(RESULT_KEY);
}

type Flow = {
  getSessionToken: () => string | null;
  setSessionToken: (token: string, expiresAt: string) => void;
  setResultPassed: () => void;
  hasResultPassed: () => boolean;
  clearSession: () => void;
};

export function useRegistrationFlow(): Flow {
  return {
    getSessionToken,
    setSessionToken,
    setResultPassed,
    hasResultPassed,
    clearSession,
  };
}
